import React from 'react'
import { Main as MainLayout } from '../layouts'

const AccessibilityPage = () => (
	<MainLayout>
		<div className="inner-paddings-x inner-paddings-y max-1440">
			<h1 className="h2">
				Accessibility Statement for <span className="basic-information website-name">Eight Sleep</span>
			</h1>
			<p>
				Eight Sleep has a commitment to ensuring that an equal experience and the website is accessible to all people, including those with disabilities. As part of this commitment, our website has
				been designed to conform to the World Wide Web Consortium (W3C) Web Content Accessibility Guidelines 2.1 AA.
				<br />
				<br />
				Eight Sleep strives to maintain an equally accessible site throughout future web updates. We recognize that there may be occasions when users experience difficulty accessing the site. If you
				experience any difficulty viewing any material on our website, please contact us at accessibility@eightsleep.com. Your feedback and ideas are extremely important to us.
			</p>
		</div>
	</MainLayout>
)

export default AccessibilityPage
